export const stripHtmlTags = (val: string): string => val.replaceAll(/<[^>]{0,10000}>/g, '');
